/**
 *
 *  useTheme
 *  React hook
 *
 *  Created by Vladimir Shishlyannikov on 28/02/2023.
 *  Copyright (c) 2016-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";

import { ThemeContext } from "../ThemeProvider";

const useTheme = () => {
  const theme = React.useContext(ThemeContext);

  if (!theme) {
    throw new Error("useTheme must be used within the ThemeProvider");
  }

  return theme;
};

export default useTheme;
